export default __webpack_public_path__ + "Image-99a97ee27172db572c0951df4e60c2bb.png";